import React from "react";
import {
  Container,
  Wrapper,
  SectionEyebrow,
  Title,
  Desc,
  Card,
  Badge,
  ProjectTitle,
  ProjectDesc,
  Chips,
  Chip,
  ContentGrid,
  HighlightsCard,
  HighlightsTitle,
  HighlightList,
  HighlightItem,
  CTASection,
  Buttons,
  ActionButton,
  SecondaryButton,
  SmallNote,
} from "./FeaturedProjectStyle";
import { featuredProject } from "../../data/constants";

const technologyChips = [
  "React",
  "TypeScript",
  "GraphQL",
  "WebSockets",
  "Node.js",
  "MongoDB",
];

const capabilityChips = [
  "Real-Time Collaboration",
  "Shared Session State",
  "Browser-Based Access",
];

const leftHighlights = featuredProject.highlights.slice(0, 3);
const rightHighlights = featuredProject.highlights.slice(3);

const FeaturedProject = () => {
  return (
    <Container id="storypoker">
      <Wrapper>
        <SectionEyebrow>Selected Work</SectionEyebrow>
        <Title>Featured Project</Title>
        <Desc>
          A selected engineering project demonstrating my work in real-time
          collaboration systems, distributed application workflows, and scalable
          SaaS platform design.
        </Desc>

        <Card>
          <Badge>Production-Oriented SaaS Platform</Badge>

          <ProjectTitle>{featuredProject.title}</ProjectTitle>

          <ProjectDesc>{featuredProject.subtitle}</ProjectDesc>

          <Chips>
            {technologyChips.map((chip) => (
              <Chip key={chip}>{chip}</Chip>
            ))}
            {capabilityChips.map((chip) => (
              <Chip key={chip} $accent>
                {chip}
              </Chip>
            ))}
          </Chips>

          <ContentGrid>
            <HighlightsCard>
              <HighlightsTitle>Architecture Highlights</HighlightsTitle>
              <HighlightList>
                {leftHighlights.map((item, index) => (
                  <HighlightItem key={index}>{item}</HighlightItem>
                ))}
              </HighlightList>
            </HighlightsCard>

            <HighlightsCard>
              <HighlightsTitle>Core Platform Capabilities</HighlightsTitle>
              <HighlightList>
                {rightHighlights.map((item, index) => (
                  <HighlightItem key={index}>{item}</HighlightItem>
                ))}
              </HighlightList>
            </HighlightsCard>
          </ContentGrid>

          <CTASection>
            <Buttons>
              <ActionButton
                href={featuredProject.links.live}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Live Platform
              </ActionButton>

              <SecondaryButton
                href={featuredProject.links.docs}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Technical Docs
              </SecondaryButton>
            </Buttons>

            <SmallNote>
              Public technical documentation includes system architecture,
              frontend and backend design, deployment overview, and selected
              implementation materials.
            </SmallNote>
          </CTASection>
        </Card>
      </Wrapper>
    </Container>
  );
};

export default FeaturedProject;
